/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_PendingInputs */

const en_login_pending = /** @type {(inputs: Login_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in…`)
};

const de_login_pending = /** @type {(inputs: Login_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung läuft…`)
};

/**
* | output |
* | --- |
* | "Signing in…" |
*
* @param {Login_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_pending = /** @type {((inputs?: Login_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_pending(inputs)
	return en_login_pending(inputs)
});